export const environment = {
  production: true,
  apiGatewayUrl: "https://api.residencemelody.com/",
  lodgifyUrlV1: "https://api.lodgify.com/v1/",
  lodgifyUrlV2: "https://api.lodgify.com/v2/",
  siteName: "Résidence Melody",
  siteUrl: "https://residencemelody.com",
  stage: "prod",
  deployUrl: "https://cloudfront.residencemelody.com",
  cdnUrl: "https://cdn.residencemelody.com",
  twicPicsUrl: "https://residence-melody.twic.pics"
};
